import { MessageManager } from "./MessageManager";
import { Reporter } from "./Reporter";
import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { HandIcon } from "../utils/HandIcon";
import { Message } from "./Message";
import { VoodooAnimation } from "./VoodooAnimation";
import { CelebrationContainer } from "./CelebrationContainer";
import { FootballFieldState } from "../scenes/match-scene/FootballFieldState";
import { MatchManager } from "../MatchManager";

export class HUD extends Phaser.Group {

    public static currentInstance: HUD;

    private static SCORE_LABEL_PX = 112;
    private static COUNTDOWN_LABEL_PY = 295;
    private static COUNTDOWN_LABEL_PX = 415;
    private static BALLS_LABEL_PY = 550;

    private levelLabel: Phaser.Text;
    private ballsLabel: Phaser.Text;
    private scoreLabel: Phaser.Text;
    private messageManager: MessageManager;
    private reporter: Reporter;
    private fpsLabel: Phaser.Text;
    private initialBalls: number;
    private scoreBoardContainer: Phaser.Group;
    private countDownLabel: Phaser.Text;
    private time: number;
    private countdownTimerEvent: Phaser.TimerEvent;
    private celebrationGroup: Phaser.Group;
    private halfSecond: boolean;

    constructor(game: Phaser.Game) {

        super(game, null, "hud", false);

        HUD.currentInstance = this;

        this.countDownLabel = null;

        this.visible = false;

        if (GameVars.isTimedLevel) {
            this.addCountdownLabel();
        } else if (!GameVars.penalties) {
            this.addBallsCounter();
        }

        this.addScoreBoard();

        this.celebrationGroup = new Phaser.Group(this.game);
        this.add(this.celebrationGroup);

        this.messageManager = new MessageManager(this.game);

        this.reporter = new Reporter(this.game);
        this.add(this.reporter);

        if (GameConstants.DEVELOPMENT) {

            this.levelLabel = new Phaser.Text(this.game, 705, 935, "" + GameVars.matchID, { font: "35px whoopass", fill: "#DAE9E9" });
            this.levelLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            this.add(this.levelLabel);

            this.fpsLabel = new Phaser.Text(this.game, 705, 965, "60", { font: "40px Arial", fill: "#ffff00", align: "center" });

            this.add(this.fpsLabel);

            this.update = () => {

                super.update();

                this.fpsLabel.text = "" + this.game.time.fps;
            };
        }
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        if (this.countdownTimerEvent) {
            this.countdownTimerEvent.pendingDelete = true;
        }

        super.destroy(destroyChildren, soft);
    }

    public start(): void {

        this.visible = true;

        if (GameVars.getInstance().firstTimePlayed) {

            GameVars.getInstance().firstTimePlayed = false;
            const handIcon = new HandIcon(this.game, GameConstants.GAME_WIDTH / 2, 350, "texture_atlas_1");
            this.add(handIcon);
            handIcon.click();
        }

        if (GameVars.isTimedLevel) {

            this.messageManager.showMessage(Message.TIMED_LEVEL);

            // el mensaje tarda 3 segundos en desaparecer
            // que el tiempo empiece a correr tras la desaparicion de este mensje
            // cuidado - 1 evento anidado
            this.game.time.events.add(2500, function (): void {
                this.countdownTimerEvent = this.game.time.events.loop(500, this.updateCountdown, this);
            }, this);
        }
    }

    public onMatchEnd(): void {

        if (this.countDownLabel) {
            this.countDownLabel.visible = false;
        }
    }

    public updateBallsCounter(highlightBallsLabel?: boolean): void {

        if (GameVars.isTimedLevel) {
            return;
        }

        this.ballsLabel.text = " " + GameVars.balls.toString() + " ";

        if (highlightBallsLabel) {
            this.game.add.tween(this.ballsLabel.scale)
                .to({ x: 1.15, y: 1.15 }, 300, Phaser.Easing.Cubic.Out, true, 0, 0, true);
        }
    }

    public onBallsManagerReadyToKickOff(): void {

        if (GameVars.balls === 3 && this.initialBalls !== 3 && !GameVars.isTimedLevel) {

            // lanzar el mensaje con un retraso para que no se solape con el de gol
            this.game.time.events.add(250, function (): void {
                this.messageManager.showMessage(Message.THREE_BALLS_LEFT);
            }, this);
        }
    }

    public onPenaltyScored(): void {

        this.messageManager.showMessage(Message.PENALTY_SCORED);

        if (GameVars.matchJustUnlocked) {
            this.celebrateMatchEnd();
        } else {
            this.reporter.onGoal();
        }
    }

    public onGoal(): void {

        if (GameVars.playerGoals > 9 || GameVars.adversaryGoals > 9) {
            this.scoreLabel.fontSize = 30;
            this.scoreLabel.y = 14;
        }

        if (GameVars.playerGoals > GameVars.adversaryGoals || GameVars.playerGoals === GameVars.adversaryGoals) {

            const fontSize = this.scoreLabel.fontSize;
            const fontColor: string = GameVars.playerGoals > GameVars.adversaryGoals ?
                "#2BB740" : "#FF7505";

            this.scoreLabel.destroy();

            this.scoreLabel = new Phaser.Text(this.game, 0, 0, GameVars.playerGoals.toString() + "-" + GameVars.adversaryGoals, { font: fontSize + "px futura-bold", fill: fontColor });
            this.scoreLabel.anchor.set(.5);
            this.scoreLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            this.scoreBoardContainer.add(this.scoreLabel);
        }

        this.scoreLabel.text = "" + GameVars.playerGoals + "-" + GameVars.adversaryGoals;

        if (this.scoreLabel.text.length > 3) {
            this.scoreLabel.fontSize = 25;
        }

        // if (GameVars.balls === 0 && GameVars.gameData.achievedMatchId === GameVars.matchID) {
        if (GameVars.balls !== 0) {

            if (GameVars.playerGoals > GameVars.adversaryGoals) {
                this.messageManager.showMessage(Message.EXTRA_GOAL);
            } else {
                this.messageManager.showMessage(Message.GOAL);
            }

            this.reporter.onGoal();
        }
    }

    public onStreakerEntry(): void {

        this.messageManager.showMessage(Message.STREAKER);
    }

    public onStrikerHit(): void {

        this.messageManager.showMessage(Message.EXTRA_BALLS);
        this.updateBallsCounter(true);
    }

    public onPowerUpSelected(powerUpType: string): void {

        if (powerUpType === GameConstants.EXTRA_BALLS) {
            this.messageManager.showMessage(Message.EXTRA_BALLS);
            this.updateBallsCounter(true);
        } else if (powerUpType === GameConstants.BALL_OF_FIRE) {
            this.messageManager.showMessage(Message.BALL_OF_FIRE);
        } else if (powerUpType === GameConstants.VOODOO) {
            this.messageManager.showMessage(Message.VOODOO);

            var voodooAnimation: VoodooAnimation = new VoodooAnimation(this.game);
            this.add(voodooAnimation);
        } else if (powerUpType === GameConstants.FREEZE_GOALKEEPER) {
            this.messageManager.showMessage(Message.FREEZE_GOALKEEPER);
        }
    }

    public celebrateMatchEnd(): void {

        // en el caso de que se este mostrando un letrero
        const celebrationContainer = new CelebrationContainer(this.game);
        this.celebrationGroup.add(celebrationContainer);
    }

    private addCountdownLabel(): void {

        this.halfSecond = false;

        this.time = GameVars.time;

        this.countDownLabel = new Phaser.Text(this.game, HUD.COUNTDOWN_LABEL_PX, HUD.COUNTDOWN_LABEL_PY,
            " " + GameVars.time + " ", { font: "450px whoopass", fill: "#DAE9E9" });
        this.countDownLabel.setShadow(8, 8, "rgba(0,0,0,1)", 0);
        this.countDownLabel.anchor.x = .5;
        this.countDownLabel.alpha = .25;
        this.countDownLabel.scale.y = GameVars.scaleY;
        FootballFieldState.currentInstance.backgroundManager.add(this.countDownLabel);
    }

    private updateCountdown(): void {

        // esto del medio segundo es para que cuando quedan 10 segundos
        // el fondo parpadee mas deprisa
        if (this.halfSecond) {
            this.halfSecond = false;
            if (this.time <= 10) {
                FootballFieldState.currentInstance.backgroundManager.pulseBackgroundAlpha();
            }
            return;
        }

        this.halfSecond = true;

        this.time--;
        this.countDownLabel.text = " " + this.time.toString() + " ";

        FootballFieldState.currentInstance.backgroundManager.pulseBackgroundAlpha();

        if (this.time % 2) {
            this.countDownLabel.alpha = .35;
        } else {
            this.countDownLabel.alpha = .25;
        }

        if (this.time === 0) {
            // parar el loop e informar al MatchModel
            this.countdownTimerEvent.pendingDelete = true;
            this.messageManager.showMessage(Message.TIME_UP);
            MatchManager.onTimeUp();
        }
    }

    private addBallsCounter(): void {

        this.initialBalls = GameVars.balls;

        const ballsCounterContainer = new Phaser.Group(this.game);
        ballsCounterContainer.x = HUD.BALLS_LABEL_PY;
        ballsCounterContainer.y = 28 * GameVars.scaleY;
        ballsCounterContainer.scale.y = GameVars.scaleY;
        this.add(ballsCounterContainer);

        const ballsFrame = new Phaser.Image(this.game, 0, 0, "texture_atlas_5", "marcador_bolas_restantes");
        ballsFrame.anchor.set(.5);
        ballsCounterContainer.add(ballsFrame);

        this.ballsLabel = new Phaser.Text(this.game, -15, 0, " " + this.initialBalls.toString() + " ", { font: "32px whoopass", fill: "#DAE9E9" });
        this.ballsLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        this.ballsLabel.anchor.set(.5);
        ballsCounterContainer.add(this.ballsLabel);
    }

    private addScoreBoard(): void {

        // la base
        this.scoreBoardContainer = new Phaser.Group(this.game);

        this.scoreBoardContainer.x = 120;
        this.scoreBoardContainer.y = 40 * GameVars.scaleY;

        this.scoreBoardContainer.scale.y = GameVars.scaleY;
        this.add(this.scoreBoardContainer);

        let scoreBoardBackground = new Phaser.Image(this.game, 0, 0, "texture_atlas_5", "marcador");
        scoreBoardBackground.anchor.set(.5);
        this.scoreBoardContainer.add(scoreBoardBackground);

        // las banderas
        let playerTeamID = GameVars.playerID;
        let playerFlagImageName = "bandera_" + GameVars.formatNumberForTextureAtlas(playerTeamID);

        const playerFlag = new Phaser.Image(this.game, -74, -3, "texture_atlas_5", playerFlagImageName);
        playerFlag.scale.set(.65);
        playerFlag.anchor.set(.5);
        this.scoreBoardContainer.add(playerFlag);

        let adversaryTeamID = GameVars.adversaryID;
        let adversaryFlagImageName: string = "bandera_" + GameVars.formatNumberForTextureAtlas(adversaryTeamID);

        const adversaryFlag = new Phaser.Image(this.game, 74, -3, "texture_atlas_5", adversaryFlagImageName);
        adversaryFlag.scale.setTo(.65);
        adversaryFlag.anchor.set(.5);
        this.scoreBoardContainer.add(adversaryFlag);

        let fontSize = GameVars.adversaryGoals > 9 ? 30 : 35;

        this.scoreLabel = new Phaser.Text(this.game, 0, -4, GameVars.playerGoals.toString() + "-" + GameVars.adversaryGoals, { font: fontSize + "px futura-bold", fill: "#D8102D" });
        this.scoreLabel.anchor.set(.5);
        this.scoreLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        this.scoreBoardContainer.add(this.scoreLabel);

        if (this.scoreLabel.text.length > 3) {
            this.scoreLabel.fontSize = 25;
        }
    }
}
